import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../core/services/cra-esn/cra-esn.service';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { PrimeNGConfig } from 'primeng/api';
import { serverError } from '@core/models/messages';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CraSelectedService } from '@core/services/cra-esn/cra-selected.service';
import Swal from 'sweetalert2';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-list-cra',
  templateUrl: './list-cra.component.html',
  styleUrls: ['./list-cra.component.css'],
})
export class ListCraComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  currentYear!: number;
  currentUser: any;
  id: any;
  listOfMonths: any;
  listCra: any;
  sortAttr = '';
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  listWorkFlowClient: any;
  startIndex: number = 0;
  endIndex: number = 5;
  pagination : boolean =false;

  formcra!: FormGroup;
  private unsubscribeAll: Subject<void> = new Subject();
  searchForm: FormGroup = this.createSearchForm();
  state = [
    { id: 1, name: 'Non envoyé' },
    { id: 2, name: 'Envoyé' },
    { id: 3, name: 'Validé' },
    { id: 4, name: 'Rejeté' },
    { id: 5, name: 'Approuvé'}
  ];

  isSearching :boolean = false;
  modalRef?: BsModalRef;
  safeDescription!: SafeHtml;

  pageSizeOptions = [5, 10, 20];

  pageSize = 5;
  currentPage = 0;
  totalElements = 0

  constructor(
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private localStorageService: LocalStorageService,
    private primengConfig: PrimeNGConfig,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
    private craSelectedService: CraSelectedService
  ) {}
  ngOnInit() {
    this.primengConfig.setTranslation({
      dayNames: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi',
      ],
      dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      monthNames: [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'août',
        'septembre',
        'octobre',
        'novembre',
        'décembre',
      ],
      monthNamesShort: [
        'janv.',
        'févr.',
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        'août',
        'sept.',
        'oct.',
        'nov.',
        'déc.',
      ],
      today: "Aujourd'hui",
      clear: 'Effacer',
    });
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.getAllListCra();
  }

  /* list list workflow General */
  getAllListCra(pageNumber : number = this.currentPage) {
    let dataPayload ={ per_page: this.pageSize, page: pageNumber }
    this.spinner.show();
    this.serviceCraEsn
      .getListCra(dataPayload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listCra = res.data;
          this.totalElements = res.total
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  /* search */
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      client_final_name: [data ? data.client_final_name : ''],
      consultant: [data ? data.consultant : ''],
      month_cra: [data ? this.formatDate(data.month_cra) : '' ],
      month_timeSheet:  [data ? this.formatDate(data.month_timeSheet) : '' ],

      state: [data ? data.state : null],
    });
  }
  onDateChange(date: Date | string): void {
    // Si date est vide ou undefined, réinitialiser le champ
    if (!date || (date instanceof Date && isNaN(date.getTime()))) {
      this.searchForm.get('month_cra')?.setValue(''); // Réinitialiser si la date est invalide ou vide
    } else {
      const formattedDate = this.formatDate(date);
      this.searchForm.get('month_cra')?.setValue(formattedDate);
    }
  }

  limitMonthYearLength(event: KeyboardEvent): void {
    const allowedKeys = [8, 46, 37, 39]; // Backspace, Delete, Left arrow, Right arrow
    if (event.key.length === 1 && !/[\d-]/.test(event.key)) {
      event.preventDefault();
    }
    // Limite le nombre de caractères saisis
    const input = (event.target as HTMLInputElement).value;
    if (input.length >= 7 && !allowedKeys.includes(event.keyCode)) {  // YYYY-MM = 7 caractères
      event.preventDefault();
    }
  }
  onMonthYearInput(event: any): void {
    const value = event.target.value;
    const isValid = /^\d{4}-\d{2}$/.test(value);
    if (!isValid && value.length > 0) {
      console.error('La date entrée est invalide');
    }
  }
  formatDate(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Mois de 01 à 12
    return `${year}-${month}`;
  }
  searchCraState:boolean=false
  searchCra(pageNumber : number = this.currentPage) {
    let data = {
      esn_name: this.searchForm.value?.esn_name,
      status: this.searchForm.value.state,
      client_name: this.searchForm.value?.client_final_name,
      full_name: this.searchForm.value?.consultant,
      date: this.searchForm.value.month_cra,
      page: pageNumber + 1,
      per_page: this.itemsPerPage,
    };
    this.spinner.show();
    this.serviceCraEsn
      .searchCra(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
            this.isSearching = true
            this.searchCraState=true
            this.listCra = res.data;
            this.totalElements = res.total;
            this.spinner.hide();
        },
        error: () => {
          this.searchCraState=false
          this.spinner.hide();
        },
      });
  }
  detailsNavigation(cra: any) {
    this.craSelectedService.setCRASelected(cra);
    this.router.navigate(['/detail-cra/', { idCra: cra.id }]);
  }

  /**
   * This method allows to  validate, cancel and reject CRA
   * @param idCra CRA identifier
   * @param type state [2: Envoyé, 3 : Validé, 4 : Rejeté]
   * @param cancel true if it's a cancel operation
   */
  validateCra(idCra: string, type: string | null, cancel?: boolean) {
      let data = {
        cra_id: idCra,
        state: type,
        rejected: cancel
      };

      let message = ''
      let confirmationMessage = ''
      if(type === '3'){
        message = 'CRA a été validé avec succès.'
        confirmationMessage = 'Voulez-vous vraiment valider ce CRA ?'
      } else if(cancel){
        message = 'CRA a été annulé avec succès.'
        confirmationMessage = 'Voulez-vous vraiment annuler ce CRA ?'
      }

      Swal.fire({
          title: confirmationMessage,
          icon: 'info',
          iconColor : '#265d91',
          showCancelButton: true,
          cancelButtonText: 'Annuler',
          confirmButtonText: 'Confirmer',
          confirmButtonColor: '#265d91',
          reverseButtons: true
      }).then((result) => {
          if (result.isConfirmed) {
            this.serviceCraEsn.validateOrRejectCra(data).subscribe({
              next: (res: any) => {
                this.toastr.success(message);
                this.getAllListCra();
              },
              error: (error) => {
                this.toastr.error(serverError);
              },
            });
          }
      });
    }
    
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.isSearching = false
    this.currentPage = 0
    this.getAllListCra(0);
  }

  getFullNameConsultant(cra: any): string{
    let name= ''
    const candidate = cra?.consultant_e_s_n?.candidate

    if(candidate){
      candidate.first_name? name = candidate.first_name : name = '--- '
      candidate.last_name? name = name.concat(' ',candidate.last_name) : name = name.concat('---')
      return name
    }
    else return '--- ---'

  }

  getStatusNameById(statusId: number){
    const index = this.state.findIndex(element => element.id === statusId)
    if(index !== -1) return this.state[index].name 
    else return '---'
  }

  getBadgeClass(status: number): string {
    switch (status) {
      case 1: return 'badge-non-envoye'; // Non envoyé
      case 2: return 'badge-envoye';     // Envoyé
      case 3: return 'badge-approuve';   // Approuvé
      case 4: return 'badge-rejete';     // Rejeté
      case 5: return 'badge-valide';     // Validé
      default: return '';
    }
  }

  getWorkflowStepName(cra: any): string{
    const roleName = cra?.nextRoleName
     return roleName ? roleName.replace(/_company\d*$/, '') : 'Consultant'
  }
  displayValidationBtn(cra : any): boolean{
    let isValidRole = false
    const currentUser = JSON.parse(this.currentUser)
    if(currentUser.employee_role_id === null)  isValidRole = this.getWorkflowStepName(cra) === "admin"
    else isValidRole = currentUser.employee_role_id === cra?.nextRoleId
    return [2, 3].includes(cra.status) && isValidRole
  }

  displayCancelBtn(cra : any): boolean{
    let canCancel = false
    if(cra?.history_cra?.length > 0 && cra.status == 3) {
      const currentUser = JSON.parse(this.currentUser)    
      canCancel = currentUser.id == cra?.history_cra[0]?.validated_by
      return canCancel
    } else return false
  }

  openModalRejectedReason(template: TemplateRef<any>, cra: any) {
      this.modalRef = this.modalService.show(template);
          const rawHtml = cra?.history_cra[0]?.report || '';
          this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }
  closeModal() {
      this.modalRef?.hide();
  }

  /**
   * Handle page change event from the paginator.
   * @param event The page event containing the new page index and page size.
   */
  onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if(this.isSearching){
        this.searchCra()
      }else{
        this.getAllListCra()
      }
  }

  /**
   * Concatenates the names of clients into a single string, separated by commas.
   * 
   * @param consultantsList - List of clients objects.
   * @returns A string of concatenated names separated by commas.
   * 
   */
  getClientsNames(clientsList: { client_final_e_s_n: { name: string} }[]): string {
    if (!Array.isArray(clientsList) || clientsList.length === 0) {
      return '';
    }

    return clientsList
      .map(client => client.client_final_e_s_n?.name)
      .join(', ');
  }

}
